import { render, staticRenderFns } from "./SendEmergencyTransportPatientTable.vue?vue&type=template&id=2fb0493f&scoped=true&lang=pug"
import script from "./SendEmergencyTransportPatientTable.vue?vue&type=script&lang=ts"
export * from "./SendEmergencyTransportPatientTable.vue?vue&type=script&lang=ts"
import style0 from "./SendEmergencyTransportPatientTable.vue?vue&type=style&index=0&id=2fb0493f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb0493f",
  null
  
)

export default component.exports